<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Create PDF</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()" *ngIf="!generatingPDF"></button>
</div>

<div class="modal-body">

  <!-- Normal state -->
  <ng-container *ngIf="!generatingPDF && !generatingError">

    <p class="text-muted small">Select files and drag them into the correct order</p>

    <div class="mb-3">
      <label class="form-label fw-semibold">File Name</label>
      <input class="form-control" [(ngModel)]="fileName" autocomplete="off" (keyup)="validateForm()">
    </div>

    <div cdkDropList (cdkDropListDropped)="drop($event)" class="d-flex flex-column gap-2">
      <div *ngFor="let item of items" cdkDrag
           class="d-flex align-items-center gap-2 p-2 border rounded bg-light"
           style="cursor: grab;">
        <fa-icon *ngIf="item.correspondenceTypeId == 1" [icon]="faEnvelopeOpen" size="lg"></fa-icon>
        <fa-icon *ngIf="item.correspondenceTypeId == 2" [icon]="faEnvelopeOpenText" size="lg"></fa-icon>
        <fa-icon *ngIf="item.correspondenceTypeId == 3" [icon]="getFileTypeIcon(item.caseFile.format)" size="lg"></fa-icon>
        <fa-icon *ngIf="item.correspondenceTypeId == 4" [icon]="faPhone" size="lg"></fa-icon>
        <fa-icon *ngIf="item.correspondenceTypeId == 5" [icon]="faSms" size="lg"></fa-icon>
        <fa-icon *ngIf="item.correspondenceTypeId == 6" [icon]="faFax" size="lg"></fa-icon>
        <span class="small">{{item.summary}}</span>
      </div>
    </div>

  </ng-container>

  <!-- Generating state -->
  <ng-container *ngIf="generatingPDF && !generatingError">
    <div class="text-center py-4">
      <h5>Generating PDF - Please do not leave the page</h5>
      <div class="spinner-border text-success mt-3" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Generating...</span>
      </div>
    </div>
  </ng-container>

  <!-- Error state -->
  <ng-container *ngIf="generatingError">
    <div class="text-center py-4">
      <h5 class="text-danger">An Error Occurred</h5>
      <div class="alert alert-danger mt-2">{{errorMessage}}</div>
    </div>
  </ng-container>

</div>

<div class="modal-footer" *ngIf="!generatingPDF" >
  <button type="button" class="btn btn-success"
    [disabled]="createButtonDisabled" (click)="createPDF()">
    Create PDF
  </button>
</div>